var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyboardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 1.5,
    fill: "white",
    stroke: "#B6B6B6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3184 17.1777H13.6816C14.543 17.1777 15.0078 16.6719 15.0078 15.8447V13.623H17.0039C17.5371 13.623 17.9336 13.3018 17.9336 12.8096C17.9336 12.5088 17.7969 12.2969 17.5303 12.0303L12.752 7.22461C12.5332 7.00586 12.2803 6.87598 12 6.87598C11.7197 6.87598 11.4668 7.00586 11.248 7.22461L6.46973 12.0303C6.19629 12.3105 6.06641 12.502 6.06641 12.8096C6.06641 13.3018 6.46289 13.623 6.99609 13.623H8.99219V15.8447C8.99219 16.6719 9.45703 17.1777 10.3184 17.1777ZM10.6396 15.8652C10.4756 15.8652 10.3594 15.7559 10.3594 15.585V12.6318C10.3594 12.502 10.3115 12.4541 10.1748 12.4541H7.98047C7.95312 12.4541 7.94629 12.4404 7.94629 12.4268C7.94629 12.4131 7.94629 12.3994 7.9668 12.3857L11.9385 8.4209C11.959 8.40723 11.9795 8.39355 12 8.39355C12.0205 8.39355 12.041 8.40723 12.0615 8.4209L16.0332 12.3857C16.0537 12.3994 16.0537 12.4131 16.0537 12.4268C16.0537 12.4404 16.0469 12.4541 16.0195 12.4541H13.8252C13.6885 12.4541 13.6406 12.502 13.6406 12.6318V15.585C13.6406 15.749 13.5176 15.8652 13.3604 15.8652H10.6396Z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardIcon);
export default __webpack_public_path__ + "static/media/keyboard-icon.da20e00518fcbc32231436631053befe.svg";
export { ForwardRef as ReactComponent };